import React from 'react'

export class Search extends React.Component {
  constructor(props) {
    super(props)
    this.state = { searchValue: decodeURIComponent(this.props.searchQuery || '').replace(/\+/g, ' ') }
  }

  handleSubmit = (event) => {
    event.preventDefault()
    this.props.searchQueryChanged(encodeURIComponent(this.state.searchValue))
  }

  handleChange = (event) => {
    this.setState({ searchValue: event.target.value })
  }

  eraseInput = (event) => {
    this.setState({ searchValue: ''})
    this.props.searchQueryChanged('')
  }

  get searchButtonClass() {
    return `search-button btn ${this.searchDisabled ? '' : 'btn-primary'}`
  }

  get eraseButtonIcon() {
    return this.searchDisabled ? '' : '\uf00d'
  }

  get searchDisabled() {
    return !this.state.searchValue
  }

  render() {
    return (
      <div className='search-form input-group'>
        <form onSubmit={ this.handleSubmit }>
          <input
            onChange={ this.handleChange }
            type='text'
            className="search-input form-control"
            placeholder={ I18n.t('discover.categories.index.search.placeholder_text') }
            value={ this.state.searchValue }
          />
          <span className="input-group-btn">
            <input
              type="submit"
              className={ this.searchButtonClass }
              value={ '\uf002' } />
          </span>
        </form>
        <span
          className="erase-button fas"
          onClick={ this.eraseInput } >
            { this.eraseButtonIcon }
          </span>
      </div>
    )
  }
}
